// Leaving a support visit: the visit is closed on the server first, and the operator is moved on only
// once that worked. If closing failed the visit is still open there, so they stay and are told.
export async function leaveSupport({ close, restoreCompany, goTo }) {
  try {
    await close();
  } catch {
    return false;
  }
  try { restoreCompany(); } catch { /* the stored company is put right on the next load */ }
  goTo();
  return true;
}
